import React from 'react';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { WhatIfsHeader } from './components/WhatIfsHeader/WhatIfsHeader';
import { StyledWrapper } from './WhatIfs.styles';

interface WhatIfsErrorProps {
  error: Error;
  onRetry: () => void;
  onClose: () => void;
}

export const WhatIfsError = ({ onClose, error, onRetry }: WhatIfsErrorProps) => (
  <StyledWrapper>
    <WhatIfsHeader onClose={onClose} />
    <Box flexGrow={1} display="flex" alignItems="center" justifyContent="center">
      <ErrorState message={error.message} onAction={onRetry} />
    </Box>
  </StyledWrapper>
);
